import 'date-fns';
import { useTheme } from "@material-ui/core/styles";
import TableHead from "@material-ui/core/TableHead";
import style from "./style.module.sass";
import TableCell from "@material-ui/core/TableCell";
import { Box, Button, TableRow, IconButton, FormControlLabel } from "@material-ui/core";
import React from "react";
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import { useTranslation } from "react-i18next";
import Checkbox from "@material-ui/core/Checkbox";
import { checkBoxStyles, deepCopy } from "../../../../utils";

export default function TableFilter({
  searchPlaces,
  setSearchPlaces,
  searchTerm,
  setTextValue,
  textValue,
  setDeleteRecall
}) {

  const { theme: { bgColors, borderColors, colors } } = useTheme();
  const { t } = useTranslation()
  const classes = checkBoxStyles(colors)()
  const setSearchArea = (e) => {
    const { name } = e.target;
    const newSearchPlaces = deepCopy(searchPlaces);
    newSearchPlaces[name] = !newSearchPlaces[name];
    setSearchPlaces(newSearchPlaces);
  }

  const resetFilter = () => {
    if (textValue !== '') {
      setTextValue('')
      setDeleteRecall(Math.floor(Math.random() * 10000))
    }
  }

  return (
    <TableHead style={{ backgroundColor: bgColors.bgPrimary0 }} className={`${style.tableFilter}`}>
      <TableRow>
        <TableCell colSpan={12} padding="checkbox">
          <Box style={{ color: colors.colorText }}
            className={`d-flex align-items-center p-3`} margin={1}>
            <Paper className={`${style.search} d-flex`}
              style={{ backgroundColor: bgColors.bgPrimary0, borderColor: borderColors.borderPrimary400 }}>
              <IconButton style={{ padding: "9px", color: colors.colorIcons }} type="submit" aria-label="search">
                <SearchIcon />
              </IconButton>
              <InputBase
                value={textValue}
                id='searchBox'
                placeholder={t('search')}
                style={{ color: colors.colorText }}
                onChange={(e) => setTextValue(e.target.value)}
                onKeyUp={(e) => {
                  if (textValue !== '' && e.key === 'Enter') {
                    searchTerm()
                  }
                }
                }
              />
            </Paper>
            <Button className={`${style.filterBtn} ml-2 mr-3`}
              onClick={() => {
                if (textValue !== '') {
                  searchTerm()
                }
              }
              }
              variant="contained"
              style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorContrast }}
            >
              {t("apply-filter")}
            </Button>
            <Button className={`${style.filterBtn} ml-2 mr-3`} onClick={() => resetFilter()} variant="contained"
              style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorContrast }}
            >
              {t("reset-filter")}
            </Button>
          </Box>
          <Box style={{ color: colors.colorPrimary500 }} className='pb-1 pl-3'  >
            <FormControlLabel control={<Checkbox name={'term'} onClick={setSearchArea} classes={{ root: classes.checkbox }} checked={!!searchPlaces['term']} />} label={t("term")} />
            <FormControlLabel control={<Checkbox name={'replacement'} onClick={setSearchArea} classes={{ root: classes.checkbox }} checked={!!searchPlaces['replacement']} />} label={t("replacement")} />
            <FormControlLabel control={<Checkbox name={'description'} onClick={setSearchArea} classes={{ root: classes.checkbox }} checked={!!searchPlaces['description']} />} label={t("description")} />
          </Box>
        </TableCell>
      </TableRow>
    </TableHead>
  )
}